<template>
  <div>
    <v-header />
    <FirstSwiper />
    <Class />
    <Salarylist />
    <Teacher />
    <SquareVideo v-if="!isMiniProgram" />
    <Hot />
    <Problem />
    <Campus />
  </div>
</template>

<script>
import VHeader from "./header/VHeader";
import FirstSwiper from "./swiper/First-swiper";
import Class from "./Class";
import Salarylist from "./Salarylist";
import SquareVideo from "./SquareVideo";
import Teacher from "./Teacher";
import Hot from "./Hot";
import Problem from "./Problem";
import Campus from "./campus/Campus";
export default {
  metaInfo() {
    return {
      // 页面标题
      title:
        "博为峰51Testing软件测试培训官网_软件测试就业培训_专注测试,领跑二十多年,软件测试人才的基地",
      // keywords + description
      meta: [
        {
          name: "keywords",
          content: "博为峰,51Testing,软件测试培训,车载测试,软件测试培训机构"
        },
        {
          name: "description",
          content:
            "博为峰51Testing软件测试培训官网,专业的软件测试培训中心,二十多年来专注为客户提供软件测试就业培训,车载测试培训,测试开发培训,企业内训,ISTQB认证培训等服务,在上海、北京、深圳、成都、南京、西安、武汉、杭州、重庆、广州、济南、郑州、苏州、石家庄、合肥、长沙、天津、青岛等十八个城市设有分支机构."
        }
      ],
      // JSON-LD 结构化数据
      script: [
        {
          vmid: "json_ld_course",
          type: "application/ld+json",
          innerHTML: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebPage",
                "@id": "https://www.51testing.net/mobile.html#webPage",
                name:
                  "博为峰51Testing软件测试培训官网_软件测试就业培训_专注测试,领跑二十多年,软件测试人才的基地",
                description:
                  "博为峰51Testing软件测试培训官网,专业的软件测试培训中心,二十多年来专注为客户提供软件测试就业培训,车载测试培训,测试开发培训,企业内训,ISTQB认证培训等服务,在上海、北京、深圳、成都、南京、西安、武汉、杭州、重庆、广州、济南、郑州、苏州、石家庄、合肥、长沙、天津、青岛等十八个城市设有分支机构.",
                url: "https://www.51testing.net/mobile.html",
                inLanguage: "zh-CN",
                publisher: {
                  "@id": "https://www.boweifeng.com/#organization"
                }
              },
              {
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name:
                      "参加博为峰51Testing就业课程培训需要具备什么基本条件？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text:
                        "统招大专及以上学历，年龄32周岁及以下，且通过入学测试评估。"
                    }
                  },
                  {
                    "@type": "Question",
                    name: "零基础、非计算机专业可以学习软件测试吗？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text:
                        "没有问题。在我们的历届学员中，有很大部分也是零经验或者非本专业转行过来的，甚至有33%以上的学员是毕业于文科专业。考虑到这一点，我们的课程安排从计算机基础、测试理论、测试技术栈，再到项目实战，分阶段循序渐进，是一套系统地科学完善的课程体系。可以帮助大家更好、更快的吸收，跟上老师的授课节奏，保质保量完成学习目标。只要用心学，都能听懂上课内容，并且掌握岗位要求的各项技术点。"
                    }
                  },
                  {
                    "@type": "Question",
                    name: "面授班和在线班有哪些区别？怎么选择？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text:
                        "两个班级差异主要是学习方式的不同，在课程体系、核心内容的设计上没有区别。面授班：校区实地面授，比较适合想在2~4个月内进行脱产学习的学员；在线班：线上授课，学习时间灵活，比较适合在职或时间受限制的学员进行学习，但这种方式对学员的自律性及学习主动性的要求相对较高。"
                    }
                  },
                  {
                    "@type": "Question",
                    name: "博为峰51Testing全国一共有多少个校区？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text:
                        "学掌门教育在上海、北京、深圳、成都、南京、西安、武汉、杭州、重庆、广州、济南、郑州、苏州、石家庄、合肥、长沙、天津、青岛等多个城市开设分支机构，满足全国广大地区学员的培训需求。"
                    }
                  },
                  {
                    "@type": "Question",
                    name: "博为峰51Testing的教学师资怎么样？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text:
                        "博为峰51Testing师资团队由具备⾏业实战经验的全职讲师组成，兼具教研与教学双重能⼒，不仅拥有经验与专业培训背景，更以⽽⼼细致的教学态度，确保每位学员获得最佳学习体验。"
                    }
                  }
                ]
              }
            ]
          }),
          __dangerouslyDisableSanitizers: ["script"]
        }
      ]
    };
  },
  components: {
    VHeader,
    FirstSwiper,
    Class,
    Salarylist,
    SquareVideo,
    Teacher,
    Hot,
    Problem,
    Campus
  },
  data() {
    return {
      isShow: Boolean,
      isMiniProgram: false
    };
  },
  mounted() {
    // document.documentElement.scrollTop || document.body.scrollTop;
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isaMiniProgram = userAgent.includes("miniprogram");
    if (isaMiniProgram) this.isMiniProgram = true;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css">
.bground {
  background: #000;
  opacity: 0.7;
}
.none-b {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue